import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-sm max-w-none text-[#5C4A3A]/80" data-id="element-53">
      <p className="text-base leading-relaxed mb-4" data-id="element-54">
        <strong className="text-[#5C4A3A]" data-id="element-55">Última actualización:</strong>{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section className="mb-6" data-id="element-56">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-57">
          1. Información que Recopilamos
        </h3>
        <p className="mb-3" data-id="element-58">
          Al adquirir "Transforma tu Vida: Un Nuevo Comienzo", recopilamos
          únicamente la información necesaria para procesar tu compra y
          entregarte el producto digital:
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-59">
          <li data-id="element-60">Dirección de correo electrónico para envío del PDF</li>
          <li data-id="element-61">
            Información de pago procesada de forma segura por nuestro procesador
            de pagos
          </li>
          <li data-id="element-62">Datos de la transacción (fecha, monto, método de pago)</li>
        </ul>
      </section>

      <section className="mb-6" data-id="element-63">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-64">
          2. Uso de tu Información
        </h3>
        <p className="mb-3" data-id="element-65">Utilizamos tu información exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-66">
          <li data-id="element-67">Procesar tu compra y entregarte el producto digital</li>
          <li data-id="element-68">Enviarte el PDF de la guía a tu correo electrónico</li>
          <li data-id="element-69">
            Gestionar solicitudes de reembolso dentro del período de garantía
          </li>
          <li data-id="element-70">Cumplir con obligaciones legales y fiscales</li>
        </ul>
      </section>

      <section className="mb-6" data-id="element-71">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-72">
          3. Protección de Datos
        </h3>
        <p className="mb-3" data-id="element-73">
          Nos comprometemos a proteger tu información personal. Implementamos
          medidas de seguridad técnicas y organizativas para salvaguardar tus
          datos contra acceso no autorizado, pérdida o alteración.
        </p>
        <p className="mb-3" data-id="element-74">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar pagos o cumplir
          con requisitos legales.
        </p>
      </section>

      <section className="mb-6" data-id="element-75">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-76">
          4. Cookies y Tecnologías Similares
        </h3>
        <p className="mb-3" data-id="element-77">
          Nuestro sitio web utiliza cookies esenciales para su funcionamiento
          básico. No utilizamos cookies de seguimiento publicitario ni de
          terceros.
        </p>
      </section>

      <section className="mb-6" data-id="element-78">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-79">
          5. Tus Derechos
        </h3>
        <p className="mb-3" data-id="element-80">Tienes derecho a:</p>
        <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-81">
          <li data-id="element-82">Acceder a tu información personal</li>
          <li data-id="element-83">Solicitar la corrección de datos inexactos</li>
          <li data-id="element-84">
            Solicitar la eliminación de tus datos (sujeto a obligaciones
            legales)
          </li>
          <li data-id="element-85">Retirar tu consentimiento en cualquier momento</li>
        </ul>
      </section>

      <section className="mb-6" data-id="element-86">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-87">
          6. Retención de Datos
        </h3>
        <p className="mb-3" data-id="element-88">
          Conservamos tu información personal solo durante el tiempo necesario
          para cumplir con los propósitos descritos en esta política, o según lo
          requiera la ley.
        </p>
      </section>

      <section className="mb-6" data-id="element-89">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-90">
          7. Cambios a esta Política
        </h3>
        <p className="mb-3" data-id="element-91">
          Podemos actualizar esta Política de Privacidad ocasionalmente. Te
          notificaremos sobre cambios significativos publicando la nueva
          política en esta página con una fecha de actualización revisada.
        </p>
      </section>

      <div className="mt-8 p-4 bg-[#FBF8F3] rounded-xl border border-[#E8A87C]/20" data-id="element-92">
        <p className="text-sm text-[#5C4A3A]/70 italic" data-id="element-93">
          Al realizar tu compra, aceptas esta Política de Privacidad y
          consientes el procesamiento de tu información personal según lo
          descrito.
        </p>
      </div>
    </div>;
}